export default {
  title: 'Service fee revenue calculator',
  description: 'Estimate what the service fee earns each month. Figures update as you type.',
  authoritative:
    'The percentage and maximum fee below are the settings that will be applied. Average order value and monthly GMV are estimates only.',
  off_notice: 'The service fee is off at this restaurant, so it earns nothing yet. Save a fee above to turn it on.',
  fields: {
    recommended: 'Recommended: {{value}}',
    aov: {
      label: 'Average order value',
      help: 'Typical basket size on your online ordering system.',
      placeholder: 'e.g. 32.50',
    },
    percentage: {
      label: 'Service fee percentage',
      help: 'Between {{min}}% and {{max}}%.',
    },
    max_amount: {
      label: 'Maximum fee per order',
      help: '{{max}} is the platform maximum.',
      below_min: 'The maximum fee must be at least {{min}}.',
    },
    monthly_gmv: {
      label: 'Monthly GMV',
      help: 'Total order value processed per month.',
      placeholder: 'e.g. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Your estimated monthly revenue',
    approximate: 'Approximate figure based on the values above — actual revenue will vary.',
    estimate_inputs: 'Based on your estimated order value and GMV — actual revenue will vary.',
    share: 'This is your {{share}}% share of the total service fee collected.',
    total_collected: 'Total service fee collected from guests at checkout',
    total_collected_note: '— paid by guests, not additional revenue on top of the figure above.',
    effective_rate: 'Effective fee rate across all orders',
  },
};
